import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { report_leftmenu, alert_deviceType, NewDeviceTypeDesc, enumAlertSubType, enumAlertType, enumAlertStatus } from '../../../app-settings';
import { SessionCheckwithStaff } from '../../../app-general';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { DownloadAlertReportComponent } from '../download-alert-report/download-alert-report.component';
import { ReportService } from '../report.service';
import { GetAlertReport } from '../report';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AlertSharedService } from '../../../_services/index';
import { SharedEventData, SharedCheckAlertReportData, SharedCheckIsAlertReportData } from '../../../api';
import { MainLayoutService } from '../../../main-layout/main-layout.service';
import { InfrastructureAlertsComponent } from '../../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { SidenavComponent } from '../../../main-layout/sidenav/sidenav.component';
import { ReportHeaderComponent } from '../report-header/report-header.component';

@Component({
  selector: 'app-alertreport',
  templateUrl: './alertreport.component.html',
  styleUrls: ['./alertreport.component.scss']
})
export class AlertreportComponent implements OnInit {

  ReportType = report_leftmenu.alertReport;
  private _onDestroy: Subject<void> = new Subject<void>();
  public EnumAlertType = alert_deviceType;
  public EnumNewDeviceType = NewDeviceTypeDesc;
  public EnumAlertSubType = enumAlertSubType;
  public EnumDeviceAlertType = enumAlertType;
  public EnumAlertStatus = enumAlertStatus;
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';

constructor(private reportService: ReportService, private mediaObserver: MediaObserver, public dialog: MatDialog, private router: Router, private alertSharedService: AlertSharedService,public mainLayoutService:MainLayoutService) {
  mediaObserver.media$.subscribe((change: MediaChange) => {

    if (change.mqAlias == this.xscurrentScreenWidth) {
      this.setupTableforXtrasmallerwidth();
    }
    else if (change.mqAlias == this.smcurrentScreenWidth) {
      this.setupTableforsmallerwidth();
    }
    else if (change.mqAlias == this.mdcurrentScreenWidth) {
      this.setupTableformidwidth();
    }
    else {
      this.setupFullTable();
    }
  })

   }

displayedAlertReportColumns: string[] = ['AlarmName', 'LastName', 'TagId', 'RoomName', 'AlertTime', 'NotifiedTime', 'AlertLevel', 'AckedTime', 'AckedMethod', 'AckStatus', 'AckedBy','PresenceOn', 'ResponseTimeSort','AlertReason'];

SiteId = "1";
IsRefreshNeed = 1;
leftbarclickevent = 0;
IsLoaded = 0;
IsFilter = 0;
IsFilterData = "";
alertdataSource;
alertreporteddata = [];
alertloading = true;
AlertReport;
downloadalertdata;
AlertDetails;
Action;
dataSourcecount;

@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
@ViewChild('Alertsort') Alertsort: MatSort;
@ViewChild('searchInput') searchInput: ElementRef;

setupTableforXtrasmallerwidth() {
  this.displayedAlertReportColumns = [ 'AlarmName', 'LastName', 'TagId'];
};

setupTableforsmallerwidth() {
  this.displayedAlertReportColumns = [ 'AlarmName', 'LastName', 'TagId','RoomName' ];
};

setupTableformidwidth()
{
  this.displayedAlertReportColumns = [ 'AlarmName', 'LastName', 'TagId','RoomName','AlertTime', 'NotifiedTime'];
}

setupFullTable() {    
  this.displayedAlertReportColumns = [ 'AlarmName', 'LastName', 'TagId', 'RoomName', 'AlertTime', 'NotifiedTime', 'AlertLevel', 'AckedTime', 'AckedMethod', 'AckStatus', 'AckedBy','PresenceOn', 'ResponseTimeSort','AlertReason'];
};

  ngOnInit() {

    if (this.IsRefreshNeed == 1) {
      var ChkIsAlertReportChanged=true;

      this.alertSharedService.currentSharedCheckIsAlertReport().pipe(takeUntil(this._onDestroy)).subscribe((SharedCheckIsAlertReportDetails: SharedCheckIsAlertReportData) => {
        var CheckIsAlertReportDataChanged = SharedCheckIsAlertReportDetails;
        if (CheckIsAlertReportDataChanged != undefined) {
          if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 1 && ChkIsAlertReportChanged ) {
            ChkIsAlertReportChanged = false;
		          if (this.IsFilter == 0) {
                  this.getAlertReport("");
              }
              else
              {
                this.getAlertReport(this.IsFilterData);
              }          
           
            CheckIsAlertReportDataChanged.IsAlertReportChanged = 0;
            this.alertSharedService.changeSharedCheckIsAlertReport(CheckIsAlertReportDataChanged);
          }
          else if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 0) {
            ChkIsAlertReportChanged = true;
          }
        }
      });

 
    }
    this.getAlertReport("");

}

getAlertReport(filterValue): void {
  try
  {
    
    this.alertloading = true;  
    var Response_Time;
    var Days;
    var Hours,Minutes,Seconds;
    if (filterValue != undefined && filterValue != null && filterValue != "") {
      this.searchInput.nativeElement.value = filterValue;
    }
    else {
      this.searchInput.nativeElement.value = '';
    }

   var alertitem : GetAlertReport = {
        siteId:this.SiteId, 
        authKey: localStorage.getItem("Authkey"),
        dateFormat:localStorage.getItem("dateFormat")
      }
      let First_name = [];
    let Last_name = [];
    this.reportService.getAlertReport(alertitem).pipe(takeUntil(this._onDestroy))
      .subscribe((Report: any[]) => {
        
        Report.forEach(function (e) {
        
          if(e.ResponseTime == '')
            e['ResponseTimeSort'] = "";
            else
            {
              Response_Time = e.ResponseTime.split(":");          
              if(Response_Time.length == 4)
              {                
                e['ResponseTime'] = Response_Time[0] + " " + Response_Time[1] + ":" + Response_Time[2] + ":" + Response_Time[3];
                Days = Response_Time[0].split("D");                
                Days = Days[0] * 24 * 60 * 60;
                Hours = Response_Time[1] * 60 * 60;
                Minutes = Response_Time[2] * 60;                
                Seconds = Days + Hours + Minutes + parseInt(Response_Time[3]);                  
              }
              else
              {                
                Hours = Response_Time[0] * 60 * 60;
                Minutes = Response_Time[1] * 60;
                Seconds = Hours + Minutes + parseInt(Response_Time[2]);
              }
              e['ResponseTimeSort'] = Seconds;
            }
     
            if (e.FirstName.includes(",")) {
              First_name = e.FirstName;
              Last_name = e.LastName;
              First_name = e.FirstName.toString().split(",");
              Last_name = e.LastName.toString().split(",");

              e["Name"] = 0;
              for (let i = 0; i < First_name.length; i++) {
                e["Name"] += First_name[i] + " " + Last_name[i] + ",";
           
              }

              e["Name"] = e["Name"].substring(1);
              e["Name"] = e["Name"].slice(0, -1);
            } else {
              e["Name"] = e.FirstName + " " + e.LastName;
            }
          });
        this.alertloading = false;
        this.AlertReport = Report;        
        this.alertdataSource = new MatTableDataSource(this.AlertReport);
        this.downloadalertdata = new MatTableDataSource(this.AlertReport);
        this.alertdataSource.data = this.AlertReport;        
        this.downloadalertdata.data = this.AlertReport;               
        setTimeout(() => {
          this.alertreporteddata = [];
          this.alertdataSource.sort = this.Alertsort;          
          this.sortingDatalist_AlertReport(this.alertdataSource);
          this.downloadalertdata.sort = this.Alertsort;
          this.sortingDatalist_AlertReport(this.downloadalertdata);
          this.downloadalertdata.connect().subscribe(data =>           
            this.alertreporteddata = data
          );   
        }, 0);
        this.alertdataSource.paginator = this.paginator.toArray()[0];
        this.dataSourcecount = this.alertdataSource.data.length;                
        this.getClearTable(this.alertdataSource.data);   

        if (filterValue != undefined && filterValue != null && filterValue != "") { // if filter value then we referesh new alert need to retain the filter.
          this.searchReport(this.IsFilterData)
        }     
        
      });
    }
    catch (err) {
      throw new Error('report.component.ts' + ' - getAlertReport() - ' + err.message);
    }
}

searchReport(filterValue: string) {
    try
    {      
      if (filterValue != null)
      {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTablealertalertdataSource defaults to lowercase matches        
        this.alertdataSource.filter = filterValue;
        this.IsFilter = 1; 
        this.IsFilterData = filterValue;        
        this.searchalertfilter();
        this.alertreporteddata = this.alertdataSource.filteredData;          
        this.dataSourcecount = this.alertreporteddata.length;                 
      }
    }
    catch (err) {
      throw new Error('report.component.ts' + ' - searchReport() - ' + err.message);
    }
}

searchalertfilter()
{
 
    var search_AckedName;
    var search_Description;
    var search_RoomInfo;
    var search_ResidentName;    
    this.alertdataSource.filterPredicate = function(data, filter: string): boolean {           
      if(data.AckedFirstName != null)
      {
        search_AckedName = data.AckedFirstName + ' ' + data.AckedLastName;        
        search_AckedName = search_AckedName.toLowerCase().includes(filter.toLowerCase());
      }
      else 
        search_AckedName = "";

      if(data.Alert != null)
      {
        search_Description = data.AlarmName + ' (' + data.Alert + ')';         
        search_Description = search_Description.toLowerCase().includes(filter.toLowerCase());
      }
      else 
        search_Description = "";


      if(data.LastName != null)
      {
        search_ResidentName = data.FirstName + ' ' + data.LastName;        
        search_ResidentName = search_ResidentName.toLowerCase().includes(filter.toLowerCase());
      }
      else 
         search_ResidentName = "";

      if(data.RoomInfo != null)
      {
        search_RoomInfo = data.RoomInfo.toLowerCase().includes(filter.toLowerCase());
      }
      else
          search_RoomInfo = "";                     
      
      return data.AlarmName.toLowerCase().includes(filter) || data.Alert.toLowerCase().includes(filter) || search_Description ||
            search_ResidentName || data.Name.toLowerCase().includes(filter) || data.NewDeviceTypeName.toLowerCase().includes(filter) ||
            search_RoomInfo || data.AlertTime.toLowerCase().includes(filter) ||
            data.NotifiedTime.toLowerCase().includes(filter) || data.TagId == filter ||
            data.AckedTime.toLowerCase().includes(filter) || data.AckedMethod.toLowerCase().includes(filter) ||
            data.AckedFirstName.toLowerCase().includes(filter) || data.AckedLastName.toLowerCase().includes(filter) || search_AckedName ||
            data.AckStatus.toLowerCase().includes(filter) || data.AlertLevel.toLowerCase().includes(filter) || 
            data.PresenceOn.toLowerCase().includes(filter) || data.ResponseTime.toLowerCase().includes(filter);  
      };   
} 

alertReportdata() {
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  if(this.alertdataSource.filter != '')
  {
    this.downloadalertdata.data = this.alertdataSource.filteredData;    
      setTimeout(() => {        
        this.alertdataSource.sort = this.Alertsort; 
        this.sortingDatalist_AlertReport(this.alertdataSource);  
        this.alertdataSource.connect().subscribe(data => this.alertreporteddata = data);   
    }, 0);      
  }       
  const dialogRef = this.dialog.open(DownloadAlertReportComponent, {
    disableClose: true,
    width: '500px',
    height: '430px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data :  this.alertreporteddata
  });
  dialogRef.afterClosed().subscribe(result => {
  });
}

getClearTable(Data) {
  try
  {
     var type = "";      
     for (var i = 0; i < Data.length - 1; i++) {
       if ((Data[i].AlarmSubTypeName === null)) {
         this.AlertDetails = Data[i].AlarmName + (type);         
       }
       else {
         this.AlertDetails = Data[i].AlarmName + (Data[i].AlarmSubTypeName);         
       }

       if (Data[i].AlertLevel === 0) {
         this.Action = 'Alert Closed';
       }
       else if (Data[i].AckedFirstName != null || Data[i].AckedLastName != null) {         
         this.Action= ('Acked By' + " " + Data[i].AckedFirstName + " " + Data[i].AckedLastName);
       }

       else {
         this.Action= "Pending";
       }       
   }
 }
 catch (err) {
   throw new Error('report.component.ts' + ' - getClearTable() - ' + err.message);
 }
}

sortingDatalist_AlertReport(DataSource)
{  
    DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {                   
          if(sortHeaderId == 'TagId' || sortHeaderId == 'AckStatus' || sortHeaderId == 'AckedBy' || sortHeaderId == 'ResponseTimeSort')
          {               
            return data[sortHeaderId]; 
          }   
          else
          { 
            return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                               
          }                                    
      }
}
CloseRightNav(){  
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  } 
  if(ReportHeaderComponent.isReportMenuClosed == false)
  {
      this.reportService.toggleReportMenuNav.emit();
  }
}

ngOnDestroy() {
  this._onDestroy.next();
   this._onDestroy.complete();
 }
}
